import './styles.scss';
import { carouselCustomResponseHandler } from './carouselResponse';

// Global variables
let serviceTokens;
let webChatInstance;
let mediaRecorder;
let audioChunks = [];
let isRecording = false;
let selectedLanguage = 'en';
let audioQueue = [];
let isPlayingAudio = false;
let currentAudio = null;


// Global variable to track the mute state
let isMuted = true;

// Function to handle the mute toggle
function toggleMute() {
    isMuted = !isMuted;
    document.querySelector('.muteButton').innerHTML = getMuteButtonHTML(isMuted);
    console.log(isMuted ? "TTS Muted" : "TTS Unmuted");

    // Stop audio if muting
    if (isMuted && currentAudio) {
        currentAudio.pause();
        currentAudio.currentTime = 0;
        isPlayingAudio = false;
        currentAudio = null;
    }
}


// Function to get the mute button HTML
// function getMuteButtonHTML(isMuted) {
//     let buttonContent;
//     if (isMuted) {
//         // Speaker off icon
//         buttonContent = `
//             <svg  viewBox="0 0 24 24" fill="none">
//                 <path d="M16 8.82V5a1 1 0 0 0-1.707-.707L9.586 9H6a1 1 0 0 0-1 1v4a1 1 0 0 0 1 1h3.586l4.707 4.707A1 1 0 0 0 16 19v-3.82l4.293 4.293 1.414-1.414L3.707 2.293 2.293 3.707 16 17.414V8.82Z" fill="currentColor"/>
//             </svg>
//             <span>Unmute TTS</span>
//         `;
//     } else {
//         // Speaker on icon
//         buttonContent = `
//             <svg  viewBox="0 0 24 24" fill="none">
//                 <path d="M15 5v14a1 1 0 0 1-1.707.707L9.586 15H6a1 1 0 0 1-1-1v-4a1 1 0 0 1 1-1h3.586l3.707-3.707A1 1 0 0 1 15 5Zm4.95 1.05-1.414 1.414A7.003 7.003 0 0 1 20 12a7.003 7.003 0 0 1-1.464 4.536l1.414 1.414A8.963 8.963 0 0 0 22 12a8.963 8.963 0 0 0-2.05-5.95Zm-2.828 2.828-1.415 1.414A3.001 3.001 0 0 1 17 12a3.001 3.001 0 0 1-.293 1.293l1.415 1.415A4.978 4.978 0 0 0 19 12a4.978 4.978 0 0 0-1.878-3.121Z" fill="currentColor"/>
//             </svg>
//             <span>Mute TTS</span>
//         `;
//     }
//     return buttonContent;
// }

// Update the getMuteButtonHTML function to use matching SVG styling
function getMuteButtonHTML(isMuted) {
    let buttonContent;
    if (isMuted) {
        // Speaker off icon - matching record button style
        buttonContent = `
            <svg width="16" height="16" viewBox="0 0 24 24" fill="#393939" xmlns="http://www.w3.org/2000/svg">
                <path d="M16 8.82V5a1 1 0 0 0-1.707-.707L9.586 9H6a1 1 0 0 0-1 1v4a1 1 0 0 0 1 1h3.586l4.707 4.707A1 1 0 0 0 16 19v-3.82l4.293 4.293 1.414-1.414L3.707 2.293 2.293 3.707 16 17.414V8.82Z"/>
            </svg>
            <span style="font-size: 13px;">Unmute</span>
        `;
    } else {
        // Speaker on icon - matching record button style
        buttonContent = `
            <svg width="16" height="16" viewBox="0 0 24 24" fill="#393939" xmlns="http://www.w3.org/2000/svg">
                <path d="M15 5v14a1 1 0 0 1-1.707.707L9.586 15H6a1 1 0 0 1-1-1v-4a1 1 0 0 1 1-1h3.586l3.707-3.707A1 1 0 0 1 15 5Zm4.95 1.05-1.414 1.414A7.003 7.003 0 0 1 20 12a7.003 7.003 0 0 1-1.464 4.536l1.414 1.414A8.963 8.963 0 0 0 22 12a8.963 8.963 0 0 0-2.05-5.95Zm-2.828 2.828-1.415 1.414A3.001 3.001 0 0 1 17 12a3.001 3.001 0 0 1-.293 1.293l1.415 1.415A4.978 4.978 0 0 0 19 12a4.978 4.978 0 0 0-1.878-3.121Z"/>
            </svg>
            <span style="font-size: 13px;">Mute</span>
        `;
    }
    return buttonContent;
}


function generateTextFromMessage(message) {
    return message.output.generic.map(message => message.text).join(' ');
}

// Function to handle the message receive event
function handleMessageReceive(event) {
    console.log("handleMessageReceive", event);
    const synthText = generateTextFromMessage(event.data);
    console.log("event.data in receive:", event.data);
    console.log("synthdata:", synthText);

    // Only process TTS if not muted
    if (!isMuted) {
        // Send synthText to TTS API
        fetch('https://speech-service.1zdn21fdio1u.us-south.codeengine.appdomain.cloud/tts/', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({ text: synthText })
        })
            .then(response => response.blob())
            .then(blob => {
                // Stop current audio if any
                if (currentAudio) {
                    currentAudio.pause();
                    currentAudio.currentTime = 0;
                }

                // Clear existing audio queue
                audioQueue = [];

                // Replace with only the latest audio
                audioQueue.push(blob);
                playNextAudio();

            })
            .catch(error => {
                console.error('Error fetching audio:', error);
            });
    }
}


// Global feedback list
let feedbackList = [];

function handleFeedbackButtons(event) {
  setTimeout(() => {
    const carousels = document.querySelectorAll('.WACWidget__MarkdownP');
    const lastCarousel = carousels[carousels.length - 1];

    if (!lastCarousel || lastCarousel.parentElement.querySelector('.feedback-buttons')) return;

    // Create feedback container
    const feedbackContainer = document.createElement('div');
    feedbackContainer.className = 'feedback-buttons feedback-center';
    feedbackContainer.innerHTML = `
      <button class="thumb-btn" style="text-align: center;" data-feedback="positive">👍</button>
      <button class="thumb-btn" style="text-align: center;" data-feedback="negative">👎</button>
    `;

    // Add CSS (only once)
    if (!document.getElementById('feedback-style')) {
      const style = document.createElement('style');
      style.id = 'feedback-style';
      style.innerHTML = `
        .feedback-buttons.feedback-center {
          display: flex;
          justify-content: center;
          gap: 10px;
          margin-top: 10px;
          font-size: 16px;
          font-weight: bold;     /* makes text bold */
          font-style: italic;
        }
        .thumb-btn {
          background-color: #f4f4f4;
          border: 1px solid #ccc;
          border-radius: 8px;
          padding: 6px 10px;
          cursor: pointer;
          font-size: 18px;
          transition: all 0.3s ease;
        }
        .thumb-btn:hover {
          background-color: #e0e0e0;
          transform: scale(1.1);
        }
       /* Center the Export button */
        .export-btn {
        display: block;
        margin: 20px auto; /* centers horizontally */
        background-color: #fff;
        border: 1.5px solid #ccc;
        border-radius: 20px;
        cursor: pointer;
        padding: 6px 10px;
        font-size: 16px;
        transition: all 0.2s ease;
        text-align: center;
        }

        .export-btn:hover {
        background-color: #f0f0f0;
        border-color: #999;
        }
        .feedback-buttons.feedback-center.thank-you{
        font-weight: bold;   /* Bold */
        font-style: italic;  /* Italic */
        color: #0072C3;      /* Optional: color to differentiate */
        font-size: 16px;     /* Optional: bigger text */
        margin-top: 10px;        /* Space above to separate from response */
        text-align: center;
}

      `;
      document.head.appendChild(style);
    }

    // Append thumbs below carousel
    lastCarousel.parentElement.appendChild(feedbackContainer);

    // Handle feedback click
    feedbackContainer.addEventListener('click', (e) => {
      if (e.target.dataset.feedback) {
        const feedbackType = e.target.dataset.feedback;
        const messageText = lastCarousel.innerText || "Carousel message";

        feedbackList.push({
          message: messageText,
          feedback: feedbackType,
          timestamp: new Date().toISOString()
        });

        console.log('Feedback stored:', feedbackList);
        //sendFeedbackToProxy(feedbackType, messageText);
        feedbackContainer.classList.add('thank-you');

        feedbackContainer.innerHTML = `<b><i>Thanks for your feedback! 🙏</i></b>`;

        
      }
    });
  }, 500);
}
// ==== Google Sheets Integration ====


// Sends feedback to Google Sheet
function sendFeedbackToProxy(feedbackType, messageText) {
  const payload = {
    message: messageText,
    feedback: feedbackType,
  };

  // Replace the URL with your Node proxy
  fetch("http://localhost:3001/send-feedback", {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(payload),
  })
    .then(response => response.text())
    .then(result => {
      console.log("✅ Feedback sent via proxy:", result);
    })
    .catch(error => {
      console.error("❌ Error sending feedback via proxy:", error);
    });
}


function playNextAudio() {
    if (audioQueue.length === 0) {
        isPlayingAudio = false;
        return;
    }

    // Stop and clean up current audio if it's already playing
    if (currentAudio) {
        currentAudio.pause();
        currentAudio.currentTime = 0;
        currentAudio = null;
    }

    const blob = audioQueue.shift();
    const audioUrl = URL.createObjectURL(blob);
    currentAudio = new Audio(audioUrl);

    if (isMuted) {
        // If muted, skip playback
        isPlayingAudio = false;
        return;
    }

    isPlayingAudio = true;

    currentAudio.onended = () => {
        isPlayingAudio = false;
        playNextAudio();
    };

    currentAudio.onerror = (error) => {
        console.error('Error playing audio:', error);
        isPlayingAudio = false;
        playNextAudio();
    };

    currentAudio.play().catch(error => {
        console.error('Error starting audio playback:', error);
        isPlayingAudio = false;
        playNextAudio();
    });
}


// Function to add the mute/unmute button
function addMuteButton(instance) {
    const button = document.createElement('button');
    button.classList.add('muteButton');
    button.innerHTML = getMuteButtonHTML(isMuted);
    button.onclick = toggleMute;

    // Matching styling with record button
    button.style.borderRadius = '999px';
    button.style.padding = '6px 12px';
    button.style.border = '2px solid #393939';  // Darker border color for mute button
    button.style.backgroundColor = '#FFFFFF';
    button.style.color = '#393939';             // Dark text to match border
    button.style.fontWeight = '500';
    button.style.fontSize = '13px';
    button.style.display = 'inline-flex';
    button.style.alignItems = 'center';
    button.style.justifyContent = 'center';
    button.style.gap = '6px';
    button.style.cursor = 'pointer';
    button.style.boxShadow = '0 1px 2px rgba(0, 0, 0, 0.08)';
    button.style.minWidth = '80px';
    button.style.width = '100px';
    button.style.maxWidth = '120px';
    button.style.whiteSpace = 'nowrap';
    button.style.overflow = 'hidden';
    button.style.textOverflow = 'ellipsis';
    button.style.margin = '5px';


    instance.writeableElements.beforeInputElement.appendChild(button);
}

function sendTextToAssistant(text) {
    const sendObject = { input: { text, language: selectedLanguage } }; // Pass selected language
    const sendOptions = {
        silent: false
    };
    webChatInstance.send(sendObject, sendOptions);
}

function onStartRecord() {
    navigator.mediaDevices.getUserMedia({ audio: true })
        .then(stream => {
            mediaRecorder = new MediaRecorder(stream);
            mediaRecorder.start();

            mediaRecorder.ondataavailable = event => {
                audioChunks.push(event.data);
            };

            mediaRecorder.onstop = () => {
                const audioBlob = new Blob(audioChunks, { type: 'audio/wav' });
                // Log the real MIME type of the blob
                console.log(audioBlob.type);
                const formData = new FormData();
                formData.append('file', audioBlob, 'recording.wav');

                fetch('https://speech-service.1zdn21fdio1u.us-south.codeengine.appdomain.cloud/stt/', {

                    method: 'POST',
                    body: formData
                })
                    .then(response => response.json())
                    .then(data => {
                        const text = data.text;
                        sendTextToAssistant(text);
                    })
                    .catch(error => {
                        console.error('Error:', error);
                    });

                audioChunks = [];
            };
        })
        .catch(error => {
            console.error('Error accessing microphone:', error);
        });
}

function onStopRecord() {
    if (mediaRecorder) {
        mediaRecorder.stop();
    }
}

function setButtonState(localIsRecording) {
    isRecording = localIsRecording;
    document.querySelector('.RecordButton').innerHTML = getButtonHTML(isRecording);
}

function getButtonHTML(isRecording) {
    let buttonContent;
    const icon = `
        <svg width="16" height="16" viewBox="0 0 32 32" fill="#0072C3" xmlns="http://www.w3.org/2000/svg">
            <path d="M23,14v3A7,7,0,0,1,9,17V14H7v3a9,9,0,0,0,8,8.94V28H11v2H21V28H17V25.94A9,9,0,0,0,25,17V14Z" />
            <path d="M16,22a5,5,0,0,0,5-5V7A5,5,0,0,0,11,7V17A5,5,0,0,0,16,22Z" />
        </svg>
    `;

    const startIcon = `
        <svg width="16" height="16" viewBox="0 0 32 32" fill="#0072C3" xmlns="http://www.w3.org/2000/svg">
            <path d="M23,14v3A7,7,0,0,1,9,17V14H7v3a9,9,0,0,0,8,8.94V28H11v2H21V28H17V25.94A9,9,0,0,0,25,17V14Z"/>
            <path d="M16,22a5,5,0,0,0,5-5V7A5,5,0,0,0,11,7V17A5,5,0,0,0,16,22ZM13,7a3,3,0,0,1,6,0V17a3,3,0,0,1-6,0Z"/>
        </svg>
    `;
    buttonContent = isRecording
        ? `${icon}<span style="font-size: 13px;">Stop</span>`
        : `${startIcon}<span style="font-size: 13px;">Record</span>`;
    return buttonContent;
}

function onButtonClick() {
    setButtonState(!isRecording);
    if (isRecording) {
        onStartRecord();
    } else {
        onStopRecord();
    }
}

function addRecordButton(instance) {
    const button = document.createElement('button');
    button.classList.add('RecordButton');
    button.innerHTML = getButtonHTML(false); // Make sure getButtonHTML also returns smaller SVG/text
    button.onclick = onButtonClick;

    // Styling for smaller button
    button.style.borderRadius = '999px';
    button.style.padding = '6px 12px';                 // Reduced padding
    button.style.border = '2px solid #0072C3';         // Slightly thinner border
    button.style.backgroundColor = '#FFFFFF';
    button.style.color = '#0072C3';
    button.style.fontWeight = '500';
    button.style.fontSize = '13px';                    // Smaller font size
    button.style.display = 'inline-flex';
    button.style.alignItems = 'center';
    button.style.justifyContent = 'center';
    button.style.gap = '6px';                          // Less spacing between icon and text
    button.style.cursor = 'pointer';
    button.style.boxShadow = '0 1px 2px rgba(0, 0, 0, 0.08)';
    button.style.minWidth = '80px';                    // Optional: fix minimum size
    button.style.width = '100px';                      // Optional: fixed width
    button.style.maxWidth = '120px';                   // Optional: prevent too wide
    button.style.whiteSpace = 'nowrap';                // Prevent wrapping
    button.style.overflow = 'hidden';
    button.style.textOverflow = 'ellipsis';
    button.style.margin = '5px';

    instance.writeableElements.beforeInputElement.appendChild(button);
}

function addLanguageToggle(instance) {
    const toggleContainer = document.createElement('div');
    toggleContainer.classList.add('toggle-container');
    toggleContainer.innerHTML = `
        <span>English &nbsp;</span>
        <label class="toggle">
          <input type="checkbox" id="languageToggle">
          <span class="slider round"></span>
        </label>
        <span> &nbsp; हिन्दी</span>
      `;
    const languageToggle = toggleContainer.querySelector('#languageToggle');
    languageToggle.onchange = (event) => {
        selectedLanguage = event.target.checked ? 'hi' : 'en';
        console.log(selectedLanguage);
    };

    instance.writeableElements.beforeInputElement.appendChild(toggleContainer);
}

async function onLoad(instance) {
    webChatInstance = instance;

    // Stop audio when assistant is restarted
    instance.on({
        type: 'restart',
        handler: () => {
            if (currentAudio) {
                currentAudio.pause();
                currentAudio.currentTime = 0;
                currentAudio = null;
            }
            audioQueue = [];
            isPlayingAudio = false;
            console.log("Assistant restarted, audio stopped.");
        },
    });

    instance.on({ type: 'receive', handler: handleMessageReceive });
    instance.on({ type: "customResponse", handler: handleFeedbackButtons });
    // addLanguageToggle(instance);
    addRecordButton(instance);
    addMuteButton(instance);
    instance.updateHomeScreenConfig({ is_on: false });
    webChatOnLoad(instance);
}

/**
 * Injects a web chat instance into the page.
 */
function addWebChat() {
    // This is the standard web chat configuration object. You can modify these values with the embed code for your
    // own assistant if you wish to try this example with your assistant. You can find the documentation for this at
    // https://web-chat.global.assistant.watson.cloud.ibm.com/docs.html?to=api-configuration#configurationobject.
    const options = {
        integrationID: "64162f69-c354-4cc5-81c3-5d3f9ea860e3", // The ID of this integration.
        region: "wxo-us-south", // The region your integration is hosted in.
        serviceInstanceID: "703d43ec-866b-4c9c-9a5f-49ecd7b32644", // The ID of your service instance.
        onLoad: onLoad,
        headerConfig: {
            showRestartButton: true,
        }
    };

    window.watsonAssistantChatOptions = options;

    const script = document.createElement('script');
    const version = options.clientVersion || 'latest';
    script.src = `https://web-chat.global.assistant.watson.appdomain.cloud/versions/${version}/WatsonAssistantChatEntry.js`;
    document.head.appendChild(script);
}

/**
 * This function is called when web chat has been loaded and is ready to be displayed.
 */
async function webChatOnLoad(instance) {
    instance.on({
        type: 'customResponse',
        handler: (event, instance) => {
            console.log("🔍 Full Custom Response Event:", event);
            if (event.data.fullMessage.context.skills['actions skill'].skill_variables.table_results.length > 0) {
                carouselCustomResponseHandler(event, instance);
                console.log("event.data:", event.data);
                console.log("ddd -- ", event.data.fullMessage.context.skills['actions skill'].skill_variables.table_results)
            }
        },
    });
    await instance.render();
}

// Launch web chat as soon as this script has loaded.
addWebChat();